<template>
  <div class="standalone-product-widget" :class="{ 'is-mobile': $store.getters.isMobile }" :style="getStyle">
    <module-block :model="model" :max-content-width="430">
      <div class="product-content hide-scroll">
        <div class="thumb">
          <img class="mx-auto w-full" :src="good.icon" alt />
        </div>
        <div class="info-box">
          <div class="flex items-center justify-between">
            <div class="price">
              <span v-if="realPriceText">{{ realPriceText }}</span>
            </div>
            <div v-if="good.is_purchase_limit" class="purchase-btn">Limit {{ good.has_purchase_num }} / {{
              good.limit_purchase_num }}</div>
          </div>
          <div class="flex items-center justify-between mt-1">
            <div class="origin-price">
              <span v-if="isShowOriginalPrice">{{ originalPriceText }}</span>
            </div>
            <div v-if="stopCountdownTimer" class="countdown">
              <div class="countdown-text">
                <i class="el-icon-time mr-1" />
                <span>{{ stopCountdownDays }}d:{{ stopCountdownHours }}:{{ stopCountdownMinutes
                }}:{{ stopCountdownSeconds }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="title-box">
          <span>{{ goodName }}</span>
          <div class="project-info" @click="handleProjectInfoClick">
            <div class="flex items-center w-[95%]">
              <img class="icon flex-shrink-0" :src="projectInfo.icon" alt />
              <div class="name flex-shrink-0">{{ projectInfo.names?.en }}</div>
              <div class="desc text-over-hide">{{ projectInfo.description }}</div>
            </div>
            <i class="el-icon-arrow-right flex-shrink-0" />
          </div>
        </div>
        <div v-if="hasContents" class="contents-box">
          <div class="items-title">{{ $t('siteBuild.includes') }}</div>
          <div class="items-list">
            <div v-for="(item, contentIndex) in good.item_contents" :key="'content' + contentIndex" class="item">
              <img :src="item.icon" class="object-contain" alt />
              <div class="text-over-hide name">
                <div class="text-center">{{ getLangIdI18n({ lang_id: item.name }, $store.state.locale.langIdData) }}
                </div>
                <div class="text-center">
                  <i class="el-icon-close" />
                </div>
                <div class="text-center">{{ item.num }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="hasGift" class="gifts-box">
          <div class="items-title">{{ $t('siteBuild.gift') }}</div>
          <div class="gift-list">
            <div v-for="(item, index) in good.gift_list" :key="'gift' + index" class="item first:mt-0">
              <img :src="item.gift_goods_logo" alt />
              <span>{{ getLangIdI18n({ lang_id: item.gift_goods_name }, $store.state.locale.langIdData) }}</span>
              <span>
                <i class="el-icon-close font-bold mr-1" />
                {{ item.num }}
              </span>
            </div>
          </div>
        </div>
        <div class="footer-bar" @click="handleSubmit">
          <div v-if="isSaleOut" class="sale-out total-price is-loading">SOLD OUT</div>
          <div v-else class="total-price" :class="{ 'is-loading': loading }">
            <i v-if="loading" class="el-icon-loading mr-2"></i>
            <span>{{ realPriceText }}</span>
          </div>
        </div>
      </div>
    </module-block>
    <desk-pay-modal v-if="deskPay.visible" ref="deskPayModal" :desk-pay="deskPay"
      :lang-id-data="$store.state.locale.langIdData" @close="closePay" />
  </div>
</template>

<script>
import { Message } from 'element-ui';
import { colord } from 'colord';
import { cloneDeep } from 'lodash-es';
import goodMixins from '../storeWidget/oneGood/goodMixins';
import DeskPayModal from '~/components/pay/deskPayModal.vue'
import countdownMixins from '~/mixins/countdownMixins';
import ModuleBlock from '~/components/common/ModuleBlock.vue'
import { getTextColor, checkUser, generateOrderParams, generatePayUrl, checkIgnoreMessage, getLangIdI18n, navTo } from '~/utils'

export default {
  name: 'StandaloneProductWidget',
  components: {
    DeskPayModal
  },
  mixins: [goodMixins, countdownMixins],
  props: {

  },
  data() {
    return {
      getLangIdI18n,
      loading: false,
      deskPay: {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      }
    }
  },
  computed: {
    getStyle() {
      const priceColor = getTextColor(this.model?.priceTextColor).color
      const priceColor80 = colord(priceColor).alpha(0.8).toRgbString()
      return {
        '--background': getTextColor(this.model?.background).color,
        '--main-text-color': getTextColor(this.model?.mainTextColor).color,
        '--second-text-color': getTextColor(this.model?.secondTextColor).color,
        '--button-background': getTextColor(this.model?.buttonBackground).color,
        '--button-text-color': getTextColor(this.model?.buttonTextColor).color,
        '--price-background': getTextColor(this.model?.priceBackground).color,
        '--price-text-color': priceColor,
        '--price-text-color-80': priceColor80
      }
    },
    projectInfo() {
      return this.$store.state.project.info?.project || {}
    },
    awaitGoods() {
      return this.$store.state.site.awaitGoods
    }
  },
  mounted() {
    this.checkBuy()
  },
  methods: {
    handleProjectInfoClick() {
      if (this.editing) return
      navTo(this, this.model.link)
    },
    checkBuy() {
      const isAim = this.awaitGoods && (this.awaitGoods.modelId === this.model.id)
      if (isAim) this.createOrder(this.awaitGoods.data)
    },
    async createOrder(goods) {
      this.loading = true
      const [err, res] = await this.$utils.to(generateOrderParams(this, goods || { ...this.currentGoods }))
      this.loading = false
      if (!err) {
        this.$store.commit('site/SET_AWAIT_GOODS', null)
        generatePayUrl(res, this)
      } else {
        !checkIgnoreMessage(err) && Message.error(err)
      }
    },
    async handleSubmit() {
      if (this.editing || this.loading || this.isSaleOut) return
      const newGoods = cloneDeep(this.good)
      await checkUser(this, () => {
        this.$store.commit('site/SET_AWAIT_GOODS', { modelId: this.model.id, data: newGoods })
      })
      await this.createOrder(newGoods)
    },
    closePay() {
      this.deskPay = {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      }
      this.$emit('refresh')
    }
  }
}
</script>

<style lang="less">
.standalone-product-widget {
  position: relative;
  padding: 20px 0;
  background: var(--background);
  max-height: calc(100vh - 68px);

  &.is-mobile {
    padding: 10px;
    max-height: calc(100vh - 58px);

    .module-block {
      padding: 0;

      .product-content {
        padding: 0 0 80px 0;
        max-height: calc(100vh - 80px);
        .title-box {
          padding: 10px;
        }
        .contents-box, .gifts-box {
          padding: 0 10px;
        }
        .footer-bar {
          padding: 10px;
        }
      }
    }
  }

  .module-block {
    padding: 0;
    overflow: hidden;
  }

  .product-content {
    max-height: calc(100vh - 108px);
    overflow: auto;
    padding-bottom: 90px;


    .info-box {
      padding: 10px 15px;
      background: var(--price-background);
      color: var(--price-text-color-80);

      .price {
        font-size: 18px;
        font-weight: bold;
        color: var(--price-text-color);
      }

      .origin-price {
        text-decoration: line-through;
      }

      .countdown {
        .countdown-text {
          display: flex;
          align-items: center;
        }
      }
    }

    .title-box {
      padding: 15px;
      font-size: 18px;
      font-weight: bold;
      color: var(--main-text-color);

      .project-info {
        padding: 5px;
        background: var(--price-background);
        border-radius: 4px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: var(--price-text-color);
        font-weight: normal;
        margin-top: 10px;
        justify-content: space-between;

        .icon {
          width: 30px;
          height: 30px;
          margin-right: 10px;
        }

        .name {
          border-right: 1px solid var(--price-text-color-80);
          padding-right: 10px;
          line-height: 1;
        }

        .desc {
          margin-left: 10px;
        }
      }
    }

    .contents-box {
      padding: 0 15px;
    }

    .gifts-box {
      padding: 0 15px;
    }

    .product-desc {
      font-size: 14px;
      color: var(--second-text-color);
      margin-top: 10px;
    }

    .items-title {
      font-size: 18px;
      font-weight: bold;
      margin-top: 20px;
      color: var(--main-text-color);
    }

    .items-list {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 10px;
      margin-top: 20px;
      color: var(--main-text-color);

      .item {
        text-align: center;

        img {
          width: 100%;
          border-radius: 4px;
          object-fit: contain;
          width: 48px;
          margin: 0 auto;
        }

        .name {
          font-size: 12px;
        }
      }
    }

    .gift-list {
      display: grid;
      gap: 10px;
      grid-template-columns: repeat(1, 1fr);
      margin-top: 20px;

      .item {
        display: flex;
        align-items: center;
        border-radius: 4px;
        color: var(--main-text-color);

        img {
          width: 60px;
          height: 60px;
          margin-right: 15px;
          border-radius: 4px;
        }

        span {
          font-size: 14px;

          &:last-child {
            margin-left: auto;
            font-size: 14px;
          }
        }
      }
    }
  }

  .footer-bar {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 15px;
    background: var(--module-bg-color);

    .total-price {
      background: var(--button-background);
      color: var(--button-text-color);
      height: 60px;
      font-size: 20px;
      font-weight: bold;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      border-radius: 999px;

      &.is-loading {
        opacity: 0.8;
        cursor: not-allowed;
        pointer-events: none;
      }
    }
  }
}
</style>
